import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { City } from './City.js';
import { CountryDecoder } from './CountryDecoder.js';
import { Province } from './Province.js';
export class SearchRegions extends AutoEncoder {
    cities = [];
    provinces = [];
    countries = [];
}
__decorate([
    field({ decoder: new ArrayDecoder(City) })
], SearchRegions.prototype, "cities", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Province) })
], SearchRegions.prototype, "provinces", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(CountryDecoder) })
], SearchRegions.prototype, "countries", void 0);
//# sourceMappingURL=SearchRegions.js.map